import {Howl} from '../../howler';
import {lerp} from "../utils/math";
import {RandomBag} from "../random/RandomBag";

export async function loadSoundEvents(options): Promise<{ [key: string]: SoundEvent }> {

    const promises = []

    for (const event in options.events) {
        const eventData = options.events[event]

        const p = Promise.all(eventData.sounds.map(async sound => {

            const soundOptions = Object.assign({
                src: options.path + sound,
                volume:0
            }, eventData.options)

            try {
                return await loadSound(soundOptions)
            } catch (e) {
                console.log("error loading sound", sound, e)
            }
        }))

        p.then(s => eventData.sounds = s)
        promises.push(p)
    }

    await Promise.all(promises)

    let eventEntries = Object.entries(options.events).map(([eventId, eventData]: any[]) => [eventId, new SoundEvent(eventData)])

    return Object.fromEntries(eventEntries) as { [key: string]: SoundEvent }

}

export type SoundEventId = string

export interface Range {
    min: number
    max: number
}

export class SoundInstance {
    sound: Howl
    id: number
    event: SoundEvent
    volume: number = 1
    rate: number = 1

    constructor(event: SoundEvent, option: Partial<PlayOption>) {

        option = Object.assign({volume: 1, rate: 1}, option)

        this.event = event
        this.sound = event.randomBag.getNext()
        this.id = this.sound.play()
        this.rate = typeof event.rate !== "number" && typeof option.rate !== "number" ? Math.random() : option.rate
        this.volume = typeof event.volume !== "number" && typeof option.volume !== "number" ? Math.random() : option.volume
        this.setRate(this.rate)
        this.setVolume(this.volume)

    }

    setRate(targetRate: number, lerpValue?: number) {
        this.rate = lerpValue !== undefined ? lerp(this.rate, targetRate, lerpValue) : targetRate;
        this.sound.rate(getValue(this.event.rate, this.rate), this.id)
    }

    setVolume(targetVolume: number, lerpValue?: number) {

        this.volume = lerpValue !== undefined ? lerp(this.volume, targetVolume, lerpValue) : targetVolume;
        this.sound.volume(getValue(this.event.volume, this.volume), this.id)
    }
}

interface PlayOption {
    volume: number
    rate: number
}

export class SoundEvent {
    sounds: Howl[] = []
    randomBag: RandomBag
    volume: number | Range = 1
    rate: number | Range = 1

    constructor(options) {
        Object.assign(this, options)

        this.sounds.forEach(s=>s.volume(0))
        this.randomBag = new RandomBag(...this.sounds)
    }


    play(option?: Partial<PlayOption>): SoundInstance {

        return new SoundInstance(this, option)
    }
}

function getValue(numberOrRange:number|Range, lerpValue:number) {

    if (typeof numberOrRange == "number")
        return numberOrRange * lerpValue
    else {
        const v = numberOrRange as Range
        return lerp(v.min !== undefined ? v.min : 0, v.max !== undefined ? v.max : 1, lerpValue)
    }
}

async function loadSound(options) {

    return new Promise((resolve, reject) => {

        options.onload = () => {
            resolve(h)
        }
        options.onloaderror = (id, error) => {
            reject({id, error})
        }
        const h = new Howl(options);
    })
}